// Local runtime config (git-ignored). Edit freely — Vite HMR refreshes on save.
// Switch envs: node scripts/configure-runtime.js <env>
// @env ci

// Runtime config template — CI. Add per-environment URLs and flags here
// (all 4 env files), not credentials. Credentials go in .env / environmentDefines.
export const API_URL = 'https://api.my.osano.dev';
export const CHAT_API_URL = 'https://chat.api.my.osano.dev';
export const AUTH_API_URL = 'https://api.osano.dev';
export const API_NAME = 'Osano B2B CI Api V2';
export const ASSESSMENTS_API_NAME = 'Osano Assessments API';
export const CM_URL = 'https://cmp-ci.osano.com/';
export const CM_LOCALE_URL = 'https://locale.cmp-ci.osano.com/';
export const ASSESSMENTS_API_URL = 'https://dsar-user-portal.api.osano.dev';
export const LOCAL_API_URL = '';
export const MFA_ISSUER = 'Osano CI';
export const DSAR_EMAIL_URL = 'osano.dev';
export const DSAR_FORM_URL = 'https://ci.datasubject.com/';
export const REMOTE_URL = 'https://my.osano.dev';
export const TRUSTHUB_DOMAIN = 'trusthub.dev';
export const UC_API_URL = 'https://uc.api.osano.dev/v2';
export const UC_CUI_URL = 'https://unifiedconsent.osano.dev';
export const UC_OPT_CSS_URL = 'https://clientapps.osano.dev/uc-opt/latest/ui.css';
export const UC_OPT_JS_URL = 'https://clientapps.osano.dev/uc-opt/latest/ui.js';
export const UC_OPT_EMBED_URL = 'https://clientapps.osano.dev/uc-opt';
export const CC_REJECT_ALL_EXCLUDED_CUSTOMERS = ['JFIJqQzRaY12itCQA'];
